// extracted by mini-css-extract-plugin
export var cardButton = "styles-module--cardButton--T4UH4";
export var content = "styles-module--content--uY3l3";
export var left = "styles-module--left--LLYyZ";
export var icon = "styles-module--icon---Ztcz";
export var title = "styles-module--title--ys0J6";
export var subtitle = "styles-module--subtitle--gAzpN";
export var right = "styles-module--right--0PuFQ";